import React, { useEffect, useState } from "react";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import Container from "react-bootstrap/Container";
import ReactPlayer from "react-player";
import { tutorialFetcher } from "../../api/requests";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { baseURL } from "../../api/dataFetcher";
import "./styles.css";

const Tutorial = () => {
  const [activeTab, setActiveTab] = useState("channel");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const video = process.env.PUBLIC_URL + "/img/videoUploadTutorial.mp4";
  const channel = process.env.PUBLIC_URL + "/img/channelUploadTutorial.mp4";
  const altImg = process.env.PUBLIC_URL + "/img/blog/1.png";

  const getData = async () => {
    setLoading(true);
    try {
      const res = await tutorialFetcher.get();
      setData(res.results);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <ContentWrapper>
      <Container fluid className="pt-5 pb-5">
        <div className="container mt-5 marginTop">
          <ul className="nav nav-tabs" style={{ paddingRight: "0px" }}>
            <li className="nav-item">
              <button
                className={`nav-link mobileLi ${
                  activeTab === "channel" ? "active" : ""
                }`}
                style={{ outline: "none" }}
                onClick={() => setActiveTab("channel")}
              >
                آموزش ساخت کانال
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link mobileLi ${
                  activeTab === "video" ? "active" : ""
                }`}
                style={{ outline: "none" }}
                onClick={() => setActiveTab("video")}
              >
                آموزش بارگذاری ویدئو
              </button>
            </li> 
          </ul>
          <div className="tab-content p-4 border border-top-0">
            {activeTab === "channel" &&
              (loading ? (
                <LoadingIndicator />
              ) : (
                <div id="channel-tutorial" style={{ textAlign: "right" }}>
                  {/* Responsive Title */}
                  <h3 className="fs-3 fs-md-2 fs-lg-1 mobileH3">
                    {data?.[0].title ? data?.[0].title : "آموزش ساخت کانال"}
                  </h3>
                  <div className="embed-responsive embed-responsive-16by9 mb-3">
                    {channel ? (
                      <ReactPlayer
                        className="embed-responsive-item"
                        style={{ marginTop: "15px" }}
                        url={channel}
                        playing={true}
                        controls
                        muted
                        width="100%"
                        height="100%"
                        light={baseURL + data?.[0].cover}
                      />
                    ) : (
                      <img src={altImg} alt="" />
                    )}
                  </div>
                  {/* Responsive Paragraph */}
                  <p className="fs-6 fs-md-5 fs-lg-4">
                    {data?.[0].content ? data?.[0].content : ""}
                  </p>
                </div>
              ))}
            {activeTab === "video" && (
              <div id="video-tutorial" style={{ textAlign: "right" }}>
                {/* Responsive Title */}
                <h3 className="fs-3 fs-md-2 fs-lg-1">
                  {data?.[1].title ? data?.[1].title : "آموزش بارگذاری ویدئو"}
                </h3>
                <div className="embed-responsive embed-responsive-16by9 mb-3">
                  {video ? (
                    <ReactPlayer
                      className="embed-responsive-item"
                      style={{ marginTop: "15px" }}
                      url={video}
                      playing={true}
                      controls
                      muted
                      width="100%"
                      height="100%"
                      light={baseURL + data?.[1].cover}
                    />
                  ) : (
                    <img src={altImg} alt="" />
                  )}
                </div>
                {/* Responsive Paragraph */}
                <p className="fs-6 fs-md-5 fs-lg-4">
                  {data?.[1].content ? data?.[1].content : ""}
                </p>
              </div>
            )}
          </div>
        </div>
      </Container>
    </ContentWrapper>
  );
};

export default Tutorial;
